import { render } from "./App.vue?vue&type=template&id=0d1ba24b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0d1ba24b&lang=less"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__